import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { CardInfo, InteractionQueue } from '../../../../Models/human-interaction/cardInfo';
import { WebClientConfigurationService } from '../../../../services/configuration/web-client-configuration.service';
import { InteractionQueueType } from '../../../../Models/enum/interactionQueueType';
import { HumanInteractionService } from '../../../../services/human-interaction.service';
import { interval } from 'rxjs';
import { GenericModalService } from '../../../../services/generic-modal.service';
import { InteractionFilterModalComponent } from '../../interaction-filter-modal/interaction-filter-modal.component';
import {AccessControlService} from '../../../../services/access-control.service';

@Component({
  selector: 'app-queue-card-list',
  templateUrl: './queue-card-list.component.html',
  styleUrls: ['./queue-card-list.component.css']
})
export class QueueCardListComponent implements OnInit {
  @Input() customQueue = false;
  @Input() queueConfig: InteractionQueue;
  @Input() pageConfig;
  @Input()
  set filter(filter: any) {
    if (filter) {
      this._filter = filter;
      this._filter.pageIndex = 1;
      this.getQueueItems(1, this._filter);
      this.getEntries(1);
    }
  }
  @Input() interactionQueueLabel: string;
  @Input() queueType: InteractionQueueType;
  @Input() columnPropertyName: string;
  @Output() searchDone: EventEmitter<any> = new EventEmitter();
  @Output() onChangePageClick: EventEmitter<any> = new EventEmitter();

  private _filter: any;
  showLabelCard: boolean;
  hasData: boolean;

  queueItems: CardInfo[];
  errorMessage: string;
  paginationConfig;
  interactionQueueItems: CardInfo[];
  pleaseWait;
  interactionFilterComponent: any = InteractionFilterModalComponent;
  lastFilter;
  userStatePermissions;

  constructor(
    private formBuilder: FormBuilder,
    private modalService: GenericModalService,
    private webClientConfig: WebClientConfigurationService,
    private humanInteractionService: HumanInteractionService,
    private accessControlService: AccessControlService
  ) { }

  ngOnInit() {
    this.pleaseWait = true;
    this.showLabelCard = this.pageConfig.showLabelCard;
    this._filter.pageSize = this.pageConfig.pageCardSize;

    interval(this.pageConfig.refreshInterval * 1000)
      .subscribe(() => {
        this.getQueueItems(this._filter.pageIndex, this._filter);
      });
  }

  getEntries(securableObjectType) {
    const coll = {};
    this.accessControlService.getAllEffectiveEntriesBySecurableObjectTypeAndUser(securableObjectType)
      .subscribe( statePermissions => {
        statePermissions.forEach( entry => {
          const objName = entry.permission.name;
          if (!coll[objName]) {
            coll[objName] = [];
          }
          coll[objName].push(entry.securableObject.securableObjectId);
        });
        this.userStatePermissions = coll;
      }, error1 => {
        this.errorMessage = error1;
        this.userStatePermissions = {};
      });
  }

  getQueueItems(pageNumber: number, filter = this._filter) {
    if (!pageNumber) return;
    this.errorMessage = "";
    this.queueItems = [];
    filter.pageIndex = pageNumber;
    filter.pageSize = this.pageConfig.pageCardSize;
    this.humanInteractionService.getPagedInteractionQueueItems(filter)
      .subscribe(res => {
        this.searchDone.emit(res.total);
        this.queueItems = res.interactionQueueItems;
        this.hasData = res.interactionQueueItems && res.interactionQueueItems.length > 0;
        this.setPaginationConfig(pageNumber, res.total);
          this.pleaseWait = false;
      },
      error => {
        this.errorMessage = error;
        this.pleaseWait = false;
      });
  }

  getPageQueueItems(pageNumber: number){
    if (!pageNumber || pageNumber > this.paginationConfig.total || this.paginationConfig.total == 0 || pageNumber == this._filter.pageIndex) return;
    this.getQueueItems(pageNumber);
  }

  setPaginationConfig(_currentPage: number, _totalItems: number) {
    this.paginationConfig = {
      itemsPerPage: this._filter.pageSize,
      pageIndex: _currentPage,
      totalItems: _totalItems,
      total: Math.ceil(_totalItems / this._filter.pageSize)
    };
  }

  showFilter() {
    let columnsToFilter;
    if (this.customQueue) {
      columnsToFilter = this.queueConfig[this.columnPropertyName].filter(
        column => column.systemField !== 8 && column.systemField !== 5
      );
    } else {
      columnsToFilter = this.queueConfig[this.columnPropertyName];
    }
    const objInitialState = {
      columnList: columnsToFilter,
      lastFilter: this.lastFilter,
      isCustomQueue: this.customQueue,
      searchMethod: (componentFilter) => {
        this.lastFilter = componentFilter;
        this._filter.initialDate = componentFilter.initialDate;
        this._filter.finalDate = componentFilter.finalDate;
        this._filter.columnsComparisonType =  componentFilter.columnsComparisonType;
        this._filter.columns = componentFilter.columns;
        this.getQueueItems(1, this._filter);
      }
    };
    this.modalService.showObjModal(this.interactionFilterComponent, `Filtro rápido`, objInitialState);
  }
}







